import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    paddingBottom: 40,
    flexDirection: 'column',
    alignItems: 'center',
  },

  contentWrapper: {
    marginTop: 20,
    paddingHorizontal: 40,
  },

  backgroundContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: 600,
    height: 190,
  },
  backgroundImage: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    maxWidth: 600,
    height: 190,
  },
  overlayDark: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.45)',
  },
  overlayContent: {
    position: 'absolute',
    bottom: 0,
    left: 40,
    fontSize: 11,
    color: 'white',
  },
  title: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    marginBottom: 15,
  },
  subtitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 900,
    marginBottom: 5,
  },
  lineBar: {
    borderTop: '2px solid white',
    width: 89,
    marginBottom: 15,
    marginLeft: 0,
  },

  boldText: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 9,
    lineHeight: 1.3,
    fontWeight: 900,
    marginBottom: 2,
  },
  text: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 9,
    lineHeight: 1.3,
    fontWeight: 400,
  },
  contactGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: 20,
    columnGap: 10,

    width: '100%',

    marginTop: 40,
  },
  gridItem: {
    width: '49%',
    flexDirection: 'column',
    alignItems: 'center',
  },
  contentBox: {
    alignItems: 'center',
    justifyContent: 'center',

    width: '100%',
    height: 137,

    border: '2px solid #ededed',
    borderRadius: 6,

    paddingVertical: 10,
    paddingHorizontal: 20,
  },

  roundedIconWrapper: {
    marginBottom: 10,
    maxWidth: 60,
    maxHeight: 60,
    width: 60,
    height: 60,
  },
  roundedIcon: {
    width: 60,
    height: 60,
    objectFit: 'fill',
  },
  contentText: {
    color: '#27343D',
    fontFamily: 'Lato',
    fontSize: 11,
    fontWeight: 900,
    textAlign: 'center',
  },
  fullWidthButton: {
    marginTop: 5,
    width: '100%',
    paddingVertical: 8,
    backgroundColor: '#000',
    alignItems: 'center',
    borderRadius: 4,
  },
  buttonText: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 400,
    textDecoration: 'none',
  },
});
